import { render, staticRenderFns } from "./TravelBooking.vue?vue&type=template&id=0890c710&scoped=true"
import script from "./TravelBooking.vue?vue&type=script&lang=js"
export * from "./TravelBooking.vue?vue&type=script&lang=js"
import style0 from "./TravelBooking.vue?vue&type=style&index=0&id=0890c710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890c710",
  null
  
)

export default component.exports